import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RotateCcw } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("Page render error:", error, info);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.routeKey !== this.props.routeKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center text-center py-24 px-6" data-testid="page-error-fallback">
          <div className="h-14 w-14 rounded-2xl bg-accent/20 flex items-center justify-center mb-5">
            <AlertTriangle className="h-7 w-7 text-secondary" strokeWidth={1.75} />
          </div>
          <h2 className="font-heading text-2xl mb-2">Something needs a gentle refresh</h2>
          <p className="text-muted-foreground max-w-md mb-6">This section ran into an unexpected hiccup. Your work is safe. Reloading usually sets things right.</p>
          <Button onClick={() => window.location.reload()} data-testid="page-error-reload" className="rounded-full bg-primary hover:bg-primary/90 gap-2">
            <RotateCcw className="h-4 w-4" /> Reload this page
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
